if(!customElements.get('custom-announcement-bar')){
    class AnnouncementBar extends HTMLElement {
        constructor(){
            super();

            this.swiperContainer = this.querySelector('.swiper-container');
            const slidesCount = this.swiperContainer.querySelectorAll('.swiper-slide').length;
            const enableSlideshow = this.dataset.enableSlideshow === 'true';

            // Only initialize swiper if slideshow is enabled AND there are multiple slides
            if(slidesCount <= 1 || !enableSlideshow) return;
            this.initSwiper();
        }

        initSwiper(){
            this.timeInterval = parseInt(this.dataset.timeInterval);

            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: true,
                spaceBetween: 0,
                centeredSlides: false,
                slidesPerView: 1,
                speed: 500,
                autoplay: {
                    delay: this.timeInterval
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();
        }

        refresh(){
            this.initSwiper();
        }
    }
    customElements.define('custom-announcement-bar', AnnouncementBar)
}
